module.exports = __webpack_public_path__ + "img/homepage-background-larger-mobile.ab369c3.png";